module.exports = __webpack_public_path__ + "img/2019111401.0b07ee2a.jpg";